import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import { ChangeUserPassword, ResetPassword } from 'api/endpoints';
import { useLocation, useNavigate } from 'react-router-dom';
import Flex from 'components/common/Flex';
import { useSelector } from 'react-redux';

const ReChangePassword = ({ hasLabel }) => {


    
      const loggedUserData = useSelector(state => state.DreamsAdminUser.userData);

    const navigate = useNavigate();
    // State
    const [formData, setFormData] = useState({
        password: '',
        newPassword: '',
        confirmPassword: ''
    });

    const location = useLocation();
    const queryData = location?.search?.split('?')[1]?.split('&');
    const LoginEmail = queryData?.[0]?.split('=')[1];
    const forgotPassKey = queryData?.[1]?.split('=')[1];

    const [loading, setLoading] = useState(false);

    // Handler
    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.newPassword === formData.confirmPassword) {
            setLoading(true);

            const finalData = {
                loginId: loggedUserData?.loginId,
                currentPassword: formData.password,
                newPassword: formData.newPassword
            }
            ChangeUserPassword(finalData).then(res => {
                toast.success(`Password updated successfully.`, {
                    theme: "colored",
                });
                setLoading(false);
                navigate("/");

            }).catch(err => {

                setLoading(false);
                toast.error("Password reset failed due to in correct current password.", {
                    autoClose: 1000,
                });

            });

        } else {
            toast.error("Confirm password does not match", {
                autoClose: 1000,
            });
        }


    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Flex direction='column mt-4 pt-4'>
            <Flex justifyContent="between" alignItems="center" className="mb-2">
                <h5>Reset Password</h5>
            </Flex>
            <Form
                className={classNames('mt-3', { 'text-left': hasLabel })}
                onSubmit={handleSubmit}
            >
                <Form.Group className="mb-3">
                    <Form.Label>Current Password</Form.Label>
                    <Form.Control
                        placeholder={!hasLabel ? 'Current Password' : ''}
                        value={formData.password}
                        name="password"
                        onChange={handleFieldChange}
                        type="password"
                    />
                </Form.Group>


                <Form.Group className="mb-3">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                        placeholder={!hasLabel ? 'New Password' : ''}
                        value={formData.newPassword}
                        name="newPassword"
                        onChange={handleFieldChange}
                        type="password"
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                        placeholder={!hasLabel ? 'Confirm Password' : ''}
                        value={formData.confirmPassword}
                        name="confirmPassword"
                        onChange={handleFieldChange}
                        type="password"
                    />
                </Form.Group>

                <Button
                    type="submit"
                    className="w-100"
                    disabled={!formData.password || !formData.confirmPassword || !formData.newPassword || loading}
                >
                    Reset password{loading && '...'}
                </Button>
            </Form>
        </Flex>
    );
};

ReChangePassword.propTypes = {
    hasLabel: PropTypes.bool
};

export default ReChangePassword;
